import logo from './logo.svg';

import { Elements } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import Button from './components/ui/Button';
import AstrologyLandingPage from './pages/AstrologyLandingPage';
import SignupPage from './pages/Signup/SignupPage';
import LoginPage from './pages/Login/LoginPage';
import ProfilePage from './pages/Profile/ProfilePage';
import GenerateMapPage from './pages/GenerateMapPage';
import AstroChartPage from './pages/AstroChartPage';
import FAQPage from './pages/FAQPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import SubscriptionPage from './pages/Subscription/SubscriptionPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
// import AstrologyMandala from './pages/AstrologyMandala';
import ResetPasswordPage from './pages/password/ResetPasswordPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import LGPDRights from './pages/legal/LGPDRights';
import PricingPage from './pages/PricingPage';
import SuccessPage from './pages/SuccessPage';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { PlanProvider } from './contexts/PlanContext';
import { PrivateRoute } from './components/PrivateRoute';
import ErrorModal from './components/ErrorModal';

import './App.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  return (
    <ErrorProvider>
    <AuthProvider>
      <PlanProvider>
      <Elements stripe={stripePromise}>
        <Router>
          <div className="min-h-screen w-full bg-gradient-to-br from-purple-50 to-pink-50 inset-0">
            <div className="relative h-full w-full">
              <Routes>
                <Route exact path="/" element={<AstrologyLandingPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
                <Route path="/generate-map" element={<PrivateRoute><GenerateMapPage /></PrivateRoute>} />
                <Route path="/meus-mapas" element={<PrivateRoute><AstroChartPage /></PrivateRoute>} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                <Route path="/subscription" element={<PrivateRoute><SubscriptionPage /></PrivateRoute>} />
                <Route path="/verify-email" element={<VerifyEmailPage />} />
                {/* <Route path="/mandala" element={<AstrologyMandala />} /> */}
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/lgpd" element={<LGPDRights />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/success" element={<SuccessPage />} />
                <Route path="/cancel" element={<Navigate to="/pricing?cancelled=true" replace />} />
                <Route path="*" element={
                  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-pink-50">
                    <div className="text-center p-8">
                      <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full flex items-center justify-center">
                        <Sparkles className="w-10 h-10 text-purple-600" />
                      </div>
                      <h1 className="text-3xl font-bold mb-3">
                        <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                          Pagina nao encontrada
                        </span>
                      </h1>
                      <p className="text-gray-600 mb-6">A pagina que voce procura nao existe.</p>
                      <Button to="/">
                        Voltar ao inicio
                      </Button>
                    </div>
                  </div>
                } />
              </Routes>
            </div>
          </div>
        </Router>
      </Elements>
      <ErrorModal />
      </PlanProvider>
    </AuthProvider>
    </ErrorProvider>
  );
}

export default App;
